<template>
  <v-chip
    class="filter-button"
    :class="{ 'filter-button_small': small }"
    :color="isActive ? 'primary' : 'bg-primary'"
    :text-color="isActive ? 'bg-gray-0' : 'primary'"
    :close="isActive"
    close-icon="ui-icon-close-circle"
    @click="handleClick"
    @click:close="resetHandler"
  >
    <span
      v-if="icon"
      class="mr-2"
      :class="icon"
    />
    <span class="text-body-1">
      {{ label }}
      <span v-if="isActive">
        ({{ activeNum }})
      </span>
    </span>
  </v-chip>
</template>

<script>
export default {
  name: 'FiltersButton',
  props: {
    label: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    activeNum: {
      type: Number,
      default: 0,
    },
    resetHandler: {
      type: Function,
      default: () => {},
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isActive() {
      return !!this.activeNum
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.filter-button {
  $close-icon-size: 24px;

  &:not(&_small).v-chip {
    height: 40px;
    border-radius: 20px;
  }

  ::v-deep .v-chip__close {
    max-width: $close-icon-size;
    max-height: $close-icon-size;
    font-size: $close-icon-size !important;
    margin-left: 8px !important;
  }
}
</style>
